// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 200px;
  max-height: 200px;
}

ngx-dropzone.custom-dropzone {
  background: transparent;
  color: #fff;
  border: 2px dashed rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  font-size: 20px;
}

ngx-dropzone.custom-dropzone.hovered {
  border-style: solid;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpbmdsZS1maWxlLXVwbG9hZC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQWdCO0VBQ2hCLGlCQUFpQjtBQUNuQjs7QUFFQTtFQUNFLHVCQUF1QjtFQUN2QixXQUFXO0VBQ1gsMkNBQTJDO0VBQzNDLGtCQUFrQjtFQUNsQixlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsbUJBQW1CO0FBQ3JCIiwiZmlsZSI6InNpbmdsZS1maWxlLXVwbG9hZC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaW1nIHtcbiAgbWF4LXdpZHRoOiAyMDBweDtcbiAgbWF4LWhlaWdodDogMjAwcHg7XG59XG5cbm5neC1kcm9wem9uZS5jdXN0b20tZHJvcHpvbmUge1xuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgY29sb3I6ICNmZmY7XG4gIGJvcmRlcjogMnB4IGRhc2hlZCByZ2JhKDI1NSwgMjU1LCAyNTUsIDAuOCk7XG4gIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgZm9udC1zaXplOiAyMHB4O1xufVxuXG5uZ3gtZHJvcHpvbmUuY3VzdG9tLWRyb3B6b25lLmhvdmVyZWQge1xuICBib3JkZXItc3R5bGU6IHNvbGlkO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/single-file-upload/single-file-upload.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gzBAAgzB","sourcesContent":["img {\n  max-width: 200px;\n  max-height: 200px;\n}\n\nngx-dropzone.custom-dropzone {\n  background: transparent;\n  color: #fff;\n  border: 2px dashed rgba(255, 255, 255, 0.8);\n  border-radius: 5px;\n  font-size: 20px;\n}\n\nngx-dropzone.custom-dropzone.hovered {\n  border-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
